/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ListAvailableDoctorsSpecialtiesResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CFMSpecialty',
        },
      },
    },
  }],
} as const;
